"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserLocationFromRequest = void 0;

var _cookiesJs = _interopRequireDefault(require("cookies-js"));

var _get = _interopRequireDefault(require("lodash/get"));

var _featureDetection = require("js-utils/feature-detection");

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getUserLocationCookie = function _getUserLocationCookie() {
  return _featureDetection.HAS_WINDOW ? _cookiesJs.default.get(_constants.USER_LOCATION_COOKIE) : {};
};

var _hasLatLng = function _hasLatLng(searchLocation) {
  return searchLocation && (0, _get.default)(searchLocation, ['latitude']) && (0, _get.default)(searchLocation, ['longitude']);
};

var getUserLocationFromRequest = function getUserLocationFromRequest(searchLocation) {
  var userLocationCookie = _getUserLocationCookie();

  if ((0, _get.default)(userLocationCookie, ['place_id'])) {
    return {
      placeId: (0, _get.default)(userLocationCookie, ['place_id'])
    };
  } else if (_hasLatLng(searchLocation)) {
    return {
      latitude: (0, _get.default)(searchLocation, ['latitude']),
      longitude: (0, _get.default)(searchLocation, ['longitude'])
    };
  } else {
    return {
      placeId: _constants.DEFAULT_USER_LOCATION
    };
  }
};

exports.getUserLocationFromRequest = getUserLocationFromRequest;
//# sourceMappingURL=userLocation.js.map